/* global fetch */
export default fetch;
